module.exports = __webpack_public_path__ + "img/logo_wht.0ec283fd.svg";